import React from 'react';

// Simple themed modal — no shadcn dialog dependency to keep it lean.
export const AdminModal = ({ open, onClose, title, children, footer, testid }) => {
  if (!open) return null;
  return (
    <div
      data-testid={testid || 'admin-modal'}
      className="fixed inset-0 z-50 bg-[#050814]/80 backdrop-blur-sm flex items-center justify-center p-4 overflow-y-auto"
      onClick={onClose}
    >
      <div
        className="bg-[#0B132B] border border-[#B8860B]/40 rounded-lg shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="px-6 py-4 border-b border-[#B8860B]/20 flex items-center justify-between">
          <h3 className="text-xl font-bold text-[#F4F1EA]">{title}</h3>
          <button
            data-testid="admin-modal-close"
            onClick={onClose}
            className="text-[#F4F1EA]/60 hover:text-[#B8860B] text-2xl leading-none"
            aria-label="Close"
          >
            ×
          </button>
        </div>
        <div className="p-6 space-y-4 text-[#F4F1EA]">{children}</div>
        {footer && (
          <div className="px-6 py-4 border-t border-[#B8860B]/20 flex justify-end gap-3">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};

export const AdminInput = ({ label, ...props }) => (
  <div>
    {label && <label className="block text-sm text-[#B8860B] mb-1">{label}</label>}
    <input
      {...props}
      className="w-full bg-[#050814] border border-[#B8860B]/30 text-[#F4F1EA] rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#B8860B] [color-scheme:dark]"
    />
  </div>
);

export const AdminTextarea = ({ label, ...props }) => (
  <div>
    {label && <label className="block text-sm text-[#B8860B] mb-1">{label}</label>}
    <textarea
      {...props}
      className="w-full bg-[#050814] border border-[#B8860B]/30 text-[#F4F1EA] rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#B8860B] min-h-[80px]"
    />
  </div>
);

export const AdminSelect = ({ label, children, ...props }) => (
  <div>
    {label && <label className="block text-sm text-[#B8860B] mb-1">{label}</label>}
    <select
      {...props}
      className="w-full bg-[#050814] border border-[#B8860B]/30 text-[#F4F1EA] rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#B8860B]"
    >
      {children}
    </select>
  </div>
);

export const StatusBadge = ({ status }) => {
  const map = {
    confirmed: 'bg-[#B8860B] text-[#F4F1EA]',
    paid: 'bg-[#B8860B] text-[#F4F1EA]',
    pending: 'bg-[#B8860B]/20 text-[#B8860B] border border-[#B8860B]/40',
    new: 'bg-[#B8860B]/20 text-[#B8860B] border border-[#B8860B]/40',
    cancelled: 'bg-red-900/40 text-red-300 border border-red-500/40',
    failed: 'bg-red-900/40 text-red-300 border border-red-500/40',
    resolved: 'bg-[#B8860B] text-[#F4F1EA]',
  };
  const cls = map[status] || 'bg-[#050814] text-[#F4F1EA]/70 border border-[#B8860B]/20';
  return (
    <span className={`inline-block px-2 py-0.5 rounded text-xs font-semibold ${cls}`}>
      {status || '—'}
    </span>
  );
};

export const formatDate = (s) => {
  if (!s) return '—';
  try {
    return new Date(s).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  } catch {
    return s;
  }
};

export const formatDateTime = (s) => {
  if (!s) return '—';
  try {
    return new Date(s).toLocaleString('en-US');
  } catch {
    return s;
  }
};

export const toDateInput = (s) => {
  if (!s) return '';
  try {
    return new Date(s).toISOString().slice(0, 10);
  } catch {
    return '';
  }
};
